export default __webpack_public_path__ + "static/media/ilustracao-homem-casa.b6276936.svg";